import useStoreValues from './use-store-values.js';

export default function usePreference({ key }) {
  const { preferences } = useStoreValues(['preferences']);
  return preferences?.[key];
}
